import React, { useState, Fragment } from "react";
import { useLocation } from "react-router-dom";
import SEO from "../../components/seo";
import LayoutOne from "../../layouts/LayoutOne";
import api from "../../api";
import toast from "react-hot-toast";

const ForgotPassword = () => {
  const { pathname } = useLocation();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await api.post("users/forgot-password/", { email });
      setMessage("Check your email for reset link!");
      toast.success("📩 Check your email for reset link!");
    } catch (err) {
      const errorMsg = err.response?.data?.error || "Something went wrong";
      setMessage("Error: " + errorMsg);
      toast.error("❌ " + errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <LayoutOne headerTop="visible">
        <div className="login-register-area pt-100 pb-100">
          <div className="container">
            <div className="row">
              <div className="ms-auto me-auto col-lg-6">
                <div className="login-register-wrapper text-center p-4 shadow-sm rounded-3 bg-white">
                  <h3 className="mb-4">Forgot Password</h3>
                  <form onSubmit={handleSubmit} className="text-start">
                    <div className="mb-3">
                      <label className="form-label">Email Address</label>
                      <input
                        type="email"
                        className="form-control border rounded-3 shadow-none"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        style={{ backgroundColor: "transparent" }}
                      />
                    </div>

                    <button
                      type="submit"
                      disabled={loading}
                      className="w-100 btn  rounded-3 py-2 mt-2"
                      style={{
                        border: "none",
                        fontWeight: "500",
                        transition: "0.3s",
                      }}
                    >
                      {loading ? "Sending..." : "Send Reset Link"}
                    </button>
                  </form>
                  {message && <p className="mt-3 text-muted">{message}</p>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

export default ForgotPassword;
